import { render, staticRenderFns } from "./BulletinBoardModal.vue?vue&type=template&id=0c2b70d6"
import script from "./BulletinBoardModal.vue?vue&type=script&lang=js"
export * from "./BulletinBoardModal.vue?vue&type=script&lang=js"
import style0 from "./BulletinBoardModal.vue?vue&type=style&index=0&id=0c2b70d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports